<div class="menu-bar-wrap">
  <div class="red-circle" *ngIf="showHamburgerRedDot"></div>
  <div class="menu-bar" (click)="showOrCloseFullPage()">
    <div class="menu-bar-line"></div>
    <div class="menu-bar-line"></div>
    <div class="menu-bar-line"></div>
  </div>
  <div class="menu-bar-fullscreen-cover" *ngIf="isShowCover" (click)="showOrCloseFullPage()"></div>
  <div [className]="'menu-bar-fullscreen ' + showScreenClassName">
    <div class="top-section">
      <div class="user-wrap">
        <img [src]="avatarUrl || assetsRouteUrl" class="avatar" />
        <div class="user-info">
          <div class="user-name">{{ userName }}</div>
          <div class="account-name">账户：{{ accountName }}</div>
        </div>
      </div>
    </div>

    <div class="bottom-section">
      <div class="user-tools main-nav-tools">
        <div class="btn default learningCenter" (click)="goLearningCenter()">学习中心</div>
        <div id="app-leader-coach" class="btn default aiCoach leaderCoach" *ngIf="hasLeaderCoach" (click)="goLeaderCoach()">我的导师<em class="new-badge" *ngIf="showMentorNewBadge">NEW</em></div>
        <div id="app-tools" class="btn default tools" *ngIf="showTools" (click)="goTools()">应用工具</div>
      </div>
      <div class="user-tools" *ngIf="(userCamp && userCamp.length > 0)">
        <div class="btn default exerciseBook" *ngIf="userCamp && userCamp.length > 0" [ngClass]="{'toastFlag':!showToastFlag}" (click)="goExerciseBook()">作业簿</div>
      </div>
      <div class="btn default change" *ngIf="multiValidUserAccount" (click)="handleSwitch()">切换账户</div>
      <div class="btn default gdpr" (click)="goGDPR()">个人信息处理请求</div>
      <div class="btn default privacy" (click)="goToTerms()" >使用条款</div>
      <div class="btn default privacy" (click)="goPrivacy()" >隐私政策</div>
      <div class="btn default logout" *ngIf="!isChannel" (click)="openLogoutDialog()">登出账户</div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/component-ui/menu-bar/component.html